import React from "react";
import Marketplace from "../components/Marketplace";

function MarketplacePage() {

    return (
        <>
  
          <Marketplace />
         
        </>
      );
    }
  export default MarketplacePage;
